export default "__VITE_ASSET__yc9ak0bZ__"